export type PurchaseLimitSource = number | null | undefined;

export function getEffectivePurchaseLimit(...limits: PurchaseLimitSource[]): number | null {
  const validLimits = limits.filter(
    (limit): limit is number => typeof limit === "number" && Number.isInteger(limit) && limit > 0
  );
  return validLimits.length > 0 ? Math.min(...validLimits) : null;
}

export function getProductQuantity<T extends { id: string | number; quantity: number }>(
  items: T[],
  productId: number
): number {
  return items.reduce(
    (total, item) => (Number(item.id) === productId ? total + item.quantity : total),
    0
  );
}
